/**
 * Soubor z `<input type="file">` jako `data:` URI (krok FAK4).
 *
 * Pouziva `FileReader`, ne `file.arrayBuffer()`: jsdom (testovaci prostredi
 * adminu) `Blob.arrayBuffer()` NEIMPLEMENTUJE, zatimco `FileReader` ano - kod,
 * ktery by se v testu musel obchazet mockem, by o sobe nic nedokazoval.
 *
 * Dve volajici obrazovky: logo dokladu (Fakturace › Nastaveni › Vzhled dokladu,
 * posila se base64 cast) a logo kancelare (Administrace › Brand, uklada se cele
 * `data:` URI do `organization.logo`).
 */

export async function readFileAsDataUrl(file: File): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error ?? new Error('file: cteni souboru selhalo'));
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject(new Error('file: FileReader nevratil data URI'));
        return;
      }
      resolve(result);
    };
    reader.readAsDataURL(file);
  });
}

/** Base64 cast `data:` URI bez prefixu - tvar, ktery ceka `contentBase64` v API. */
export async function readFileAsBase64(file: File): Promise<string> {
  const dataUrl = await readFileAsDataUrl(file);
  const comma = dataUrl.indexOf(',');
  if (comma < 0) throw new Error('file: data URI bez oddelovace');
  return dataUrl.slice(comma + 1);
}
